import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonApiService } from '../../common-api.service';
import { Remark } from './remark.interface';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';
import { SnackbarService } from '../../snackbar.service';


@Component({
    selector: 'app-remark.form',
    templateUrl: './remark.form.component.html',
    styleUrls: ['./remark.form.component.css']
})
export class RemarkFormComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private api: CommonApiService,
        private router: Router,
        public dialog: MatDialog,
        private snackbar: SnackbarService,
    ) { }

    public model = 'remark'
    public remark = {} as Remark;
    isFormDisabled = true;
    result: string;
    onSaveDisable = false;

    ngOnInit() {
        let remarkId = this.route.snapshot.params.id
        if (remarkId === 'create') {
            this.isFormDisabled = false;
        }
        else {
            this.getRemark(Number(remarkId));
        }
    }

    getRemark(remarkId: number) {
        this.api.get(this.model, remarkId).subscribe(
            (data: any) => {
                if (data) {
                    this.remark = data;
                }
            }
        );
    }

    save(formValid:any) {
        if(formValid == false){
            this.snackbar.warning("Please fill mandatory fields.");
            return;
        }
        this.onSaveDisable = true;
        this.api.createUpdate(this.model, this.remark).subscribe(
            (data: any) => {
                if (data) {
                    this.remark = data;
                    this.isFormDisabled = true;
                    this.snackbar.success('Saved Successfully!');
                    this.router.navigate([`/${this.model}/${data.id}`]);
                    this.onSaveDisable = false;
                }
            },
            error => {
                this.snackbar.error(error.error.message)
                this.onSaveDisable = false;
            }
        );
    }
    edit(){
        this.isFormDisabled = false;
    }

    discardChanges(): void {
		const message = `Are you sure you want to discard the changes?`
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = {
			title: "Discard Changes",
			message: message
		}
		const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			// return true or false or undefined , hence we can handle the functionality on true and false likewise here
			if (this.result) {
                if(this.remark.id){
                    this.isFormDisabled = true;
                    this.getRemark(this.remark.id);
                }else{
                    this.router.navigate([`/remark`]);
                }
			}
		});
	}

    create(){
        this.redirectTo('remark/create');
    }

    //redirects to the expected route
    //this function will redirect to a dummy route and quickly return to the destination route without the user realizing it.
    redirectTo(uri:string){  
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
        this.router.navigate([uri]));
    }

}
